import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { Toaster } from "sonner";
import { store, persistor } from "./lib/redux/root";

// Pages
import HomePage from "./pages/HomePage";
import UploadPage from "./pages/UploadPage";
import SuccessPage from "./pages/SuccessPage";
import UnauthorizedPage from "./pages/UnauthorizedPage";
import NotFoundPage from "./pages/NotFoundPage";

// Layout
import ProductLayout from "./layouts/ProductLayout";
import AllLocationsPage from "./layouts/AllLocationPage";

function App() {
	return (
		<>
			<Toaster position='top-right' richColors />
			<GoogleReCaptchaProvider
				reCaptchaKey={import.meta.env.VITE_RECAPTCHA_SITE_KEY || ""}
			>
				<Provider store={store}>
					<PersistGate loading={null} persistor={persistor}>
						<BrowserRouter>
							<Routes>
								{/* Landing page */}
								<Route path='/' element={<AllLocationsPage />} />
								<Route path='/:product' element={<AllLocationsPage />} />

								{/* Product routes with layout */}
								<Route path='/:product/:slug' element={<ProductLayout />}>
									<Route index element={<HomePage />} />
									<Route path='upload' element={<UploadPage />} />
									<Route path='order/success' element={<SuccessPage />} />
									<Route path='unauthorized' element={<UnauthorizedPage />} />
								</Route>

								{/* 404 page */}
								<Route path='/404' element={<NotFoundPage />} />
								<Route path='*' element={<Navigate to='/404' replace />} />
							</Routes>
						</BrowserRouter>
					</PersistGate>
				</Provider>
			</GoogleReCaptchaProvider>
		</>
	);
}

export default App;
